// Each stage type keeps its own colour so stages can be told apart (the legend uses the same maps).
// Normal stages: light tint fill, mid-tone border, dark text. Start and end are solid so they stand out.

export const styleType = {
  startConversation: 'rounded,filled',
  normalTraditional: 'rounded,filled',
  normalJoR: 'rounded,filled',
  normalFbOptin: 'rounded,filled',
  normalEmbeddedApp: 'rounded,filled',
  normalScoredResponse: 'rounded,filled',
  normalScoredRanking: 'rounded,filled',
  endConversation: 'filled',
  notExist: 'filled,dashed',
  normalConditionalBranching: 'rounded,filled',
  normalDrillDown: 'rounded,filled',
  stalledTraffic: 'rounded,filled,solid'
}

export const colorType = {
  startConversation: '#1E3A5F', // Navy
  normalTraditional: '#EAF1FB', // Blue tint
  normalFbOptin: '#E4F3FC', // Sky tint
  normalJoR: '#FDF3E1', // Amber tint
  normalEmbeddedApp: '#E3F5F2', // Teal tint
  normalConditionalBranching: '#FDECE6', // Orange tint
  normalDrillDown: '#F1F3F6', // Slate tint
  normalScoredResponse: '#FCE8EF', // Rose tint
  normalScoredRanking: '#F1EBFB', // Violet tint
  endConversation: '#0D9488', // Teal
  notExist: '#FFFFFF' // White
}

// Stages with screening methods fill from this colour into their own tint
export const methodsGradientStart = '#FBE3A7'

export const shapeType = {
  startConversation: 'box',
  normalTraditional: 'box',
  normalFbOptin: 'box',
  normalJoR: 'box',
  normalEmbeddedApp: 'box',
  normalScoredResponse: 'box',
  normalScoredRanking: 'box',
  endConversation: 'box',
  notExist: 'ellipse',
  normalConditionalBranching: 'box',
  normalDrillDown: 'box'
}

export const shapePeripheries = {
  selectedStage: 2,
  otherStage: 1
}

export const fontSizeType = {
  selectedStage: '21 pt',
  otherStage: '14 pt'
}

export const arrowShape = {
  normalConditionalBranching: 'normal',
  startConversation: 'normal',
  normalTraditional: 'normal',
  normalFbOptin: 'normal',
  normalJoR: 'normal',
  normalEmbeddedApp: 'normal',
  normalScoredResponse: 'normal',
  normalScoredRanking: 'normal',
  endConversation: 'dot',
  notExist: 'onormal',
  normalDrillDown: 'normal'
}

export const fontColorType = {
  normalConditionalBranching: '#8A3412',
  startConversation: '#FFFFFF',
  normalTraditional: '#1E3A5F',
  normalFbOptin: '#0C5A8A',
  normalJoR: '#7A4E05',
  normalEmbeddedApp: '#0B5F57',
  normalScoredResponse: '#8C1D45',
  normalScoredRanking: '#4C2A85',
  endConversation: '#FFFFFF',
  notExist: '#5C6E8A',
  normalDrillDown: '#334155'
}

export const borderColourType = {
  startConversation: '#1E3A5F',
  normalTraditional: '#7C9CC9',
  normalFbOptin: '#5AAFE6',
  normalJoR: '#E0A63B',
  normalEmbeddedApp: '#3BAA9C',
  normalConditionalBranching: '#EB8A64',
  normalDrillDown: '#94A3B8',
  normalScoredResponse: '#E26D93',
  normalScoredRanking: '#9B7BD4',
  endConversation: '#0D9488',
  notExist: '#94A3B8',
  stalledTraffic: '#16A34A'
}

// Defaults for every graph: no white sheet over the dotted canvas, soft slate arrows and muted labels
export const graphDefaults = 'bgcolor="transparent"\n' +
  'node [fontname="Helvetica" penwidth="1.4" margin="0.2,0.08"]\n' +
  'edge [color="#94A3B8" fontname="Helvetica" fontsize="11" fontcolor="#5C6E8A" arrowsize="0.8"]\n'



// WEBPACK FOOTER //
// ./src/components/shared/stylingForTree.js